// export DsfDataPanelPrimary from "./primary.vue";
// export DsfDataPanelDiscrete from "./discrete.vue";
// export DsfDataPanelGroup from "./primaryGroup.vue";
// export DsfDataPanelOne from "./one.vue";
// export DsfDataPanelTwo from "./two.vue";

export const DsfDataPanelPrimary=dsf.defineLazyComponent('DsfDataPanelPrimary',()=>require('./primary'));
export const DsfDataPanelDiscrete=dsf.defineLazyComponent('DsfDataPanelDiscrete',()=>require('./discrete'));
export const DsfDataPanelGroup=dsf.defineLazyComponent('DsfDataPanelGroup',()=>require('./primaryGroup'));
export const DsfDataPanelOne=dsf.defineLazyComponent('DsfDataPanelOne',()=>require('./one'));
export const DsfDataPanelTwo=dsf.defineLazyComponent('DsfDataPanelTwo',()=>require('./two'));